import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { gsap } from "gsap";
import { testimonial } from "../../data/links";
import TestimonialCard from "./TestimonialCard";
import api from "../../utilis/api";
const Testinomial = ({ data }) => {
  const slidesRef = useRef([]);
  const swiperRef = useRef(null);
  const [testimonials, setTestimonials] = useState([]);
  useEffect(() => {
    slidesRef.current.forEach((slide, i) => {
      gsap.fromTo(
        slide,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          delay: i * 0.2,
          scrollTrigger: {
            trigger: slide,
            start: "top 85%",
            toggleActions: "play none none none",
          },
        },
      );
    });
  }, []);

  const API = "/testimonial";

  // Fetch testimonials safely
  const fetchTestimonials = async () => {
    try {
      const res = await api.get(API);
      // Ensure we always have an array

      setTestimonials(
        Array.isArray(res.data?.testimonials) ? res.data?.testimonials : [],
      );
    } catch (err) {
      console.error("Failed to fetch testimonials:", err);
      setTestimonials([]);
    }
  };

  useEffect(() => {
    fetchTestimonials();
  }, []);

  return (
    <div className="bg-black py-[3rem] gradient flex flex-col items-center">
      <div className="md:w-[500px] w-full text-center flex flex-col gap-6">
        <h1
          className="font-syne text-2xl md:text-5xl font-bold "
          data-aos="fade-up" // animation type
          data-aos-delay="100"
        >
          {data?.title}
        </h1>
        <p
          data-aos="fade-up" // animation type
          data-aos-delay="300"
          className="font-outfit text-[16px] font-light"
        >
          {data?.detail}
        </p>
      </div>
      <div className="relative mt-8 w-full max-w-7xl px-4">
        <Swiper
          modules={[Autoplay, Pagination]}
          loop={true}
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          spaceBetween={20}
          slidesPerView={1} // default for mobile
          breakpoints={{
            640: { slidesPerView: 2, spaceBetween: 20 },
            768: { slidesPerView: 3, spaceBetween: 25 },
            1024: { slidesPerView: 3, spaceBetween: 30 },
            1280: { slidesPerView: 3, spaceBetween: 30 },
          }}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          pagination={{
            el: ".testimonial-pagination",
            clickable: true,
          }}
          className="crafted-swiper w-full p-[2rem]"
        >
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div ref={(el) => (slidesRef.current[index] = el)}>
                <TestimonialCard data={item} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="testimonial-pagination mt-6 flex justify-center"></div>
      </div>
    </div>
  );
};

export default Testinomial;
